import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseTrackTopPlaylistAppearancesProps {
  trackId: string;
  date?: Date;
  page: number;
  limit?: number;
}

export const useTrackTopPlaylistAppearances = ({
  trackId,
  date,
  page,
  limit = 10,
}: UseTrackTopPlaylistAppearancesProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const offset = (page - 1) * limit;

  return useTRPCQuery(
    trpcMusicAPI.tracks.topPlaylistAppearances.queryOptions({
      trackId,
      date,
      offset,
      limit,
      ...shareTokenInput,
    })
  );
};
